import { useClient } from '@composables/use-clients';
import { PostRequestArgsType } from '@api/v1/types';
import { urls } from '@api/urls';
import { withTryCatch } from '@api/v1/error-handlers';

export type EmailVerificationCodeEmailSerializer = {
  verificationCode: string;
  email: string;
  message: string;
};

export type PostEmailVerificationCodeEmailPayloadType = (
  Pick<EmailVerificationCodeEmailSerializer, 'verificationCode'>
);
export type PostEmailVerificationCodeEmailResponseType = (
  Pick<EmailVerificationCodeEmailSerializer, 'email' | 'message'>
);

export const apiFetchEmailVerificationCodeEmail = async ({
  payload,
  errorConfig = {},
  callbacks = {},
}: PostRequestArgsType<PostEmailVerificationCodeEmailPayloadType>) => {
  const impl = async () => {
    const { client } = useClient('public');
    const res = await client.post({
      url: urls.v1.emailVerificationCodeEmail(),
      payload,
    });
    return res;
  };

  return withTryCatch({ impl, errorConfig, callbacks });
};
